if (!customElements.get('yc-video-carousel')) {
  class YCVideoCarousel extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.yc-video-carousel__item'));
      if (this.items.length === 0) return;
      
      this.currentIndex = 0;
      this.total = this.items.length;
      
      this.autoRotate = this.dataset.autoRotate === 'true';
      this.changeSlidesSpeed = parseInt(this.dataset.changeSlidesSpeed, 10) * 1000 || 5000;
      this.autoplayInterval = null;

      this.updateItems();
      this.startAutoplay();
      window.addEventListener('resize', this.updateItems.bind(this));
      
      this.setupTouchEvents();
      this.setupItemEvents();
    }

    startAutoplay() {
      if (!this.autoRotate) return;
      this.stopAutoplay();
      this.autoplayInterval = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.total;
        this.updateItems();
      }, this.changeSlidesSpeed);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
      }
    }

    updateItems() {
      const isMobile = window.innerWidth < 768;
      const baseWidth = isMobile ? 260 : 320;
      const gapValue = parseFloat(getComputedStyle(this).getPropertyValue('--yc-video-carousel-item-gap'));
      const gap = Number.isFinite(gapValue) ? gapValue : (isMobile ? 16 : 24);

      this.items.forEach((item, i) => {
        let offset = i - this.currentIndex;
        
        if (offset < -Math.floor(this.total / 2)) offset += this.total;
        if (offset > Math.floor(this.total / 2)) offset -= this.total;
        
        const abs = Math.abs(offset);
        const sign = Math.sign(offset);
        
        let scale = 1;
        let translateX = 0;
        let opacity = 1;
        let zIndex = 10 - abs;
        
        const sideScale = 0.85;
        const visualSideWidth = baseWidth * sideScale;
        
        if (abs === 0) {
          scale = 1;
          translateX = 0;
          opacity = 1;
          zIndex = 10;
          item.classList.add('is-active');
        } else {
          scale = sideScale;
          const firstOffset = (baseWidth / 2) + gap + (visualSideWidth / 2);
          const extraOffset = (abs - 1) * (visualSideWidth + gap);
          translateX = sign * (firstOffset + extraOffset);
          opacity = abs > 2 ? 0 : 1; 
          zIndex = 5;
          item.classList.remove('is-active');
        }

        item.style.transform = `translate(calc(-50% + ${translateX}px), -50%) scale(${scale})`;
        item.style.zIndex = zIndex;
        item.style.opacity = opacity;
        item.style.pointerEvents = abs > 2 ? 'none' : 'auto';

        const video = item.querySelector('video');
        if (video) {
          if (abs === 0) {
            if (video.paused) {
              video.play().catch(e => console.log('Autoplay prevented', e));
            }
          } else {
            if (!video.paused || video.currentTime > 0) {
              video.pause();
              video.currentTime = 0;
            }
          }
        }
      });
    }

    setupTouchEvents() {
      let touchStartX = 0;
      let touchEndX = 0;
      
      const trackContainer = this.querySelector('.yc-video-carousel__track-container');
      if (trackContainer) {
        trackContainer.addEventListener('mouseenter', this.stopAutoplay.bind(this));
        trackContainer.addEventListener('mouseleave', this.startAutoplay.bind(this));

        trackContainer.addEventListener('touchstart', e => {
          this.stopAutoplay();
          touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        trackContainer.addEventListener('touchend', e => {
          touchEndX = e.changedTouches[0].screenX;
          const swipeThreshold = 50;
          if (touchStartX - touchEndX > swipeThreshold) {
            this.currentIndex = (this.currentIndex + 1) % this.total;
            this.updateItems();
          } else if (touchEndX - touchStartX > swipeThreshold) {
            this.currentIndex = (this.currentIndex - 1 + this.total) % this.total;
            this.updateItems();
          }
          this.startAutoplay();
        }, { passive: true });
      }
    }

    setupItemEvents() {
      this.items.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          if (i === this.currentIndex) return; 
          e.preventDefault();
          this.currentIndex = i;
          this.updateItems();
        });

        const muteBtn = item.querySelector('.yc-video-carousel__mute-btn');
        const video = item.querySelector('video');
        if (muteBtn && video) {
          muteBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation(); 
            video.muted = !video.muted;
            if (video.muted) {
              item.querySelector('.icon-mute').style.display = 'block';
              item.querySelector('.icon-unmute').style.display = 'none';
            } else {
              item.querySelector('.icon-mute').style.display = 'none';
              item.querySelector('.icon-unmute').style.display = 'block';
            }
          });
        }
      });
    }
  }
  customElements.define('yc-video-carousel', YCVideoCarousel);
}
